import { render, staticRenderFns } from "./evaluationStatistical.vue?vue&type=template&id=28e57311&scoped=true"
import script from "./evaluationStatistical.vue?vue&type=script&lang=js"
export * from "./evaluationStatistical.vue?vue&type=script&lang=js"
import style0 from "./evaluationStatistical.vue?vue&type=style&index=0&id=28e57311&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e57311",
  null
  
)

export default component.exports